<template>
  <section>
    <div class="row">
      <div class="col-md-12">
        <p>
          Use the following to create/manage templates with selected
          columns/ranges for customizing the Batch Intel templates across all
          organizations.
        </p>
      </div>
    </div>
    <div class="row">
      <div class="col-4">
        <div class="row mb-2">
          <div class="col-md-1">
            <a href="#" @click="init()"><i class="fas fa-sync"></i></a>
          </div>
          <div class="col-md-10">
            <div class="input-group">
              <span class="input-group-text">template</span>
              <input
                ref="inputAddTemplate"
                class="form-control"
                v-if="isAdd"
                v-model="templateName"
                placeholder="enter new template name"
                @blur="updateNewTemplate"
              />
              <select v-else class="form-select" v-model="template">
                <option
                  v-for="template of biTemplates"
                  :key="template.id"
                  :value="template.id"
                >
                  {{ template.name }}
                </option>
              </select>
              <button v-if="isAdd" class="btn btn-link">
                <i class="fas fa-save"></i>
              </button>
              <button v-else class="btn btn-link" @click="addTemplate">
                <i class="fas fa-plus"></i>
              </button>
            </div>
          </div>
          <div class="col-md-1"></div>
        </div>
        <div class="row mb-2">
          <div class="col-md-1"></div>
          <div class="col-md-10">
            <div v-if="isColumn" class="input-group">
              <span class="input-group-text">column</span>
              <select v-model="column" class="form-select">
                <option
                  v-for="column of columns"
                  :value="column.code"
                  :key="column.id"
                >
                  {{ column.name }}
                </option>
              </select>
            </div>
          </div>
          <div class="col-md-1"></div>
        </div>
        <div v-if="isRange" class="row mb-2">
          <div class="col-md-1"></div>
          <div class="col-md-6">
            <div class="input-group">
              <span class="input-group-text">add range</span>
              <!-- <input
                v-model="range.min"
                type="number"
                class="form-control text-right"
                placeholder="min"
              />
              <span class="custom-hyphen">-</span> -->
              <input
                type="number"
                v-model="range.max"
                class="form-control text-right"
                placeholder="max"
              />
              <button class="btn btn-link" @click="saveRange">
                <i class="fas fa-plus"></i>
              </button>
            </div>
          </div>
          <div class="col-md-1"></div>
        </div>
        <div v-if="isRange" class="row mb-2">
          <div class="col-md-1"></div>
          <div class="col-md-10">
            <div class="input-group">
              <span class="input-group-text">ranges</span>
              <ul class="custom-list">
                <li
                  v-for="range of ranges"
                  :key="range.id"
                  @click="showTexts(range)"
                  :class="{
                    'custom-selected-range': range.id === selectedRange?.id,
                  }"
                >
                  {{ formatValue(range.min) }} - {{ formatValue(range.max) }}
                  <a
                    href="#"
                    class="custom-list-remove"
                    @click="removeRange(range)"
                    ><i class="fas fa-trash"></i
                  ></a>
                </li>
              </ul>
            </div>
          </div>
          <div class="col-md-1"></div>
        </div>
        <div class="custom-table">
          <z-table
            :value="biTemplates"
            sortOn="id"
            sortDir="asc"
            :isSingleRowDetail="false"
            :columns="tableColumns"
            class="table table-bordered table-striped"
          >
            <template v-slot:tbody="props">
              <td>
                <a href="#" @click="showTemplate(props.row.id)">{{
                  props.row.name
                }}</a>
              </td>
              <td>{{ props.row.column }}</td>
              <td class="custom-column-60">
                <a href="#" @click="removeTemplate(props.row)">remove</a>
              </td>
            </template>
          </z-table>
        </div>
      </div>
      <div class="col">
        <div v-if="isSelectedRange" class="custom-texts">
          <div class="row">
            <div class="col">
              <span
                >Suggested message text options for range
                {{ formatRange() }}</span
              >
            </div>
            <div class="col-2">
              <select class="form-select" v-model="tag" @change="tagChanged">
                <option
                  v-for="tag of tags"
                  :key="tag.id"
                  :value="tag.value"
                  :disabled="tag.disabled"
                >
                  {{ tag.name }}
                </option>
              </select>
            </div>
            <div class="col-2"></div>
          </div>
          <div class="input-group mt-1">
            <span class="input-group-text">add text</span>
            <input
              v-model="clipText"
              ref="clipText"
              class="form-control"
              placeholder="text"
            />
            <button class="btn btn-link" @click="saveClipText">
              <i class="fas fa-plus"></i>
            </button>
          </div>
          <ul class="custom-list custom-full-width mt-1">
            <li v-for="item of selectedRange?.clipTexts" :key="item.id">
              {{ item.text }}
              <a
                href="#"
                class="custom-list-remove"
                @click="removeClipText(item)"
                ><i class="fas fa-trash"></i
              ></a>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <div class="row mt-2">
      <div class="col-6">
        <div class="custom-buttons">
          <button
            v-if="isSave"
            class="btn btn-primary me-2"
            :class="{ 'btn-danger': isSave }"
            @click="performSave()"
          >
            Save
          </button>
        </div>
      </div>
      <div class="col-6"></div>
    </div>
  </section>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import ZTable from '@/Components/ZElements/Table'
import ZSelect from '@/Components/ZElements/Select'
import TextAreaVue from '../ZElements/TextArea.vue'
export default {
  name: 'batch-intel-templates',
  components: {
    ZTable,
    ZSelect,
  },
  data() {
    return {
      templateName: null,
      range: {
        id: null,
        min: null,
        max: null,
      },
      isSave: false,
      isAdd: false,
      isSelectedRange: false,
      selectedRange: null,
      clipText: null,
      tag: 'label',
    }
  },
  async mounted() {
    await this.init()
  },
  computed: {
    ...mapGetters('configuration', [
      'setting',
      'biTemplates',
      'selectedBiTemplate',
    ]),
    ...mapGetters('usercardio', { allColumns: 'columns' }),
    ...mapGetters('coaching', ['mergeTags']),
    template: {
      get() {
        let _data = null
        if (this.selectedBiTemplate) {
          _data = this.selectedBiTemplate.id
        }
        return _data
      },
      set(value) {
        this.showTemplate(value)
      },
    },
    columns() {
      let _columns = []
      if (this.allColumns) {
        _columns = this.allColumns.filter((x) => x.isFilter)
      }
      return _columns
    },
    isColumn() {
      let _is = false
      if (this.selectedBiTemplate) {
        _is = true
      }
      return _is
    },
    column: {
      get() {
        let _data = null
        if (this.selectedBiTemplate) {
          _data = this.selectedBiTemplate.column
        }
        return _data
      },
      set(value) {
        this.setSelectedBiTemplateData({
          name: 'column',
          value: value,
        })
      },
    },
    isRange() {
      let _is = false
      if (this.column) {
        _is = true
      }
      return _is
    },
    ranges() {
      let _data = []
      if (this.selectedBiTemplate) {
        _data = this.selectedBiTemplate.ranges
      }
      return _data
    },
    tableColumns() {
      return [
        {
          field: 'name',
          label: 'Name',
          sortable: false,
        },
        {
          field: 'column',
          label: 'Column',
          sortable: false,
        },
        {
          field: 'id',
          label: '',
          sortable: false,
          class: 'z-column-60-center',
        },
      ]
    },
    tags() {
      let _tags = []
      if (this.mergeTags) {
        _tags = this.mergeTags
      }
      return _tags
    },
  },
  methods: {
    ...mapActions('configuration', [
      'getBiTemplates',
      'saveSetting',
      'setSelectedBiTemplate',
      'setSelectedBiTemplateData',
    ]),
    ...mapActions('usercardio', [
      'resetSelectedView',
      'setCustomColumn',
      'getCustomViewsConfig',
      'setSelectedView',
      'updateCustomView',
      'saveCustomViewsConfig',
      'applyCustomViews',
    ]),
    ...mapActions('coaching', ['getMergeTags']),
    async init() {
      this.isAdd = false
      this.isSave = false
      this.templateName = null
      this.column = null
      this.isAdd = false
      this.showDelete = false
      this.isSelectedRange = false
      this.range = {
        id: null,
        min: null,
        max: null,
      }
      this.selectedRange = null
      this.clipText = null
      await this.getMergeTags()
      await this.getBiTemplates({
        name: 'BatchIntel',
        classification: 'Templates',
      })
    },
    selectTemplate() {
      this.isAdd = false
      this.isSave = false
      console.log('Selected a Template', this.template)
    },
    addTemplate() {
      let $this = this
      this.templateName = null
      this.setSelectedBiTemplateData({
        name: 'newTemplate',
        value: null,
      })
      this.isAdd = TextAreaVue
      this.isSave = true
      setTimeout(() => {
        $this.$refs.inputAddTemplate.focus()
      }, 250)
    },
    updateNewTemplate() {
      this.isAdd = false
      this.setSelectedBiTemplateData({
        name: 'updateTemplate',
        value: this.templateName,
      })
      this.isSave = true
    },
    removeTemplate(template) {
      this.setSelectedBiTemplateData({
        name: 'removeTemplate',
        value: template.id,
      })
      this.isAdd = false
      this.isSave = true
    },
    showTemplate(id) {
      this.isAdd = false
      this.isSave = false
      this.setSelectedBiTemplateData({
        name: 'setTemplate',
        value: id,
      })
    },
    saveRange() {
      let newMax = this.range.max ? this.range.max : 0
      let previousMax = 0
      if (this.ranges) {
        if (this.ranges.length > 0) {
          previousMax = this.ranges[this.ranges.length - 1].max
        }
      }
      let newMin = parseFloat(previousMax + 0.0001)
      if (newMax > 0 && previousMax === 0) {
        newMin = 0.5
      }
      this.setSelectedBiTemplateData({
        name: 'range',
        value: {
          id: null,
          min: newMin,
          max: newMax,
        },
      })
      // this.setSelectedBiTemplateData({
      //   name: 'range',
      //   value: this.range,
      // })
      this.isSave = true
      this.range = {
        id: null,
        min: null,
        max: null,
      }
    },
    removeRange(range) {
      console.log('Removing Range', range)
      this.setSelectedBiTemplateData({
        name: 'removeRange',
        value: range.id,
      })
      this.isSave = true
    },
    showTexts(range) {
      this.selectedRange = JSON.parse(JSON.stringify(range))
      if (
        this.selectedRange.clipTexts === undefined ||
        this.selectedRange.clipTexts === null
      ) {
        this.selectedRange.clipTexts = []
      }
      this.isSelectedRange = true
      console.log('Selected Range', this.selectedRange)
    },
    reselectRange() {
      let found = this.ranges.find((x) => x.id === this.selectedRange.id)
      if (found) {
        this.selectedRange = JSON.parse(JSON.stringify(found))
      }
    },
    formatRange() {
      let _range = ''
      if (this.selectedRange) {
        let min = 0
        let max = 0
        if (this.selectedRange.min) {
          min = this.selectedRange.min.toFixed(0)
        }
        if (this.selectedRange.max) {
          max = this.selectedRange.max.toFixed(0)
        }
        _range = `${min} - ${max}`
      }
      return _range
    },
    formatValue(item) {
      let value = 0
      if (item) {
        if (item !== 0 && item !== 0.0001) {
          value = Math.ceil(item)
        }
      }
      return value
    },
    saveClipText(item) {
      console.log('Save Clip Text', item)
      this.setSelectedBiTemplateData({
        name: 'clipText',
        id: this.selectedRange.id,
        value: this.clipText,
      })
      this.reselectRange()
      this.clipText = null
      this.isSave = true
    },
    removeClipText(item) {
      console.log('Remove Clip Text', item)
      this.setSelectedBiTemplateData({
        name: 'removeClipText',
        id: this.selectedRange.id,
        value: item.id,
      })
      this.reselectRange()
      this.isSave = true
    },
    tagChanged() {
      if (this.tag.trim() !== '') {
        let el = this.$refs.clipText
        // Get the current selection start and end positions
        const start = el.selectionStart
        const end = el.selectionEnd

        // Get the current value of the input element
        const value = el.value

        // Construct the new value with the text inserted at the cursor position
        const newValue =
          value.substring(0, start) + this.tag + value.substring(end)

        this.clipText = newValue
        // Set the new value to the input element
        el.value = newValue

        // Move the cursor to the end of the inserted text
        const newCursorPosition = start + this.tag.length
        el.setSelectionRange(newCursorPosition, newCursorPosition)

        // Focus the input element to ensure the cursor is visible
        el.focus()
      }
      this.tag = 'label'
      this.isSave = true
    },
    async performSave() {
      // save
      console.log('Saving Template', this.biTemplates)
      await this.saveSetting({
        id: this.setting ? this.setting.id : null,
        orgid: 1,
        Classification: 'Templates',
        Name: 'BatchIntel',
        TextValue: JSON.stringify(this.biTemplates),
        IsInactive: 0,
      })
      await this.init()
    },
  },
}
</script>
<style lang="scss" scoped>
.custom-buttons {
  position: relative;
  float: right;
}
.custom-table {
  width: auto;
  height: 255px;
  max-height: 255px;
  overflow-x: hidden;
  overflow-y: auto;
}
.custom-hyphen {
  padding-left: 5px;
  padding-right: 5px;
}

.custom-list {
  position: relative;
  list-style-type: none;
  padding: 0;
  margin: 0;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  width: 75%;
  padding-left: 10px;
  padding-right: 10px;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  li {
    position: relative;
    padding-top: 5px;
    padding-bottom: 5px;
    cursor: pointer;
  }
  li:not(:last-child) {
    border-bottom: 1px solid #ced4da;
  }
  li:hover {
    background-color: #9ac2ff;
    color: #000;
  }
}
.custom-list-remove {
  font-size: 0.8em;
  text-align: right;
  float: right;
  padding-right: 10px;
  color: rgb(107, 0, 0);
}
.custom-texts {
  width: 100%;
}
.custom-full-width {
  width: 100%;
}
.custom-selected-range {
  background-color: #0d6efd;
  color: #fff;
}
</style>
